import React from 'react';
import { Icons } from './Icons';

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center text-sm font-medium text-indigo-600 dark:text-indigo-400 mb-8 hover:underline transition-colors"
    >
      <Icons.ArrowLeft className="w-4 h-4 mr-2" />
      Back to Home
    </button>
  );
};

export default BackButton;
